<template>
  <div class="container">
    <Modal
      ref="modal"
      title="手続きが完了しました"
      agreeButtonText="ダッシュボードへ"
      :closeButton="false"
      :overlayClose="false"
      :bodyCenter="true"
      :bodyScrollable="false"
      :visibleNeverShowCheckbox="false"
      @agreeButtonClicked="goToDashboard"
    >
      <div class="thankyou">
        <i class="el-icon-circle-check" style="color: #f88; font-size: 7rem;margin-bottom: 30px;" />
        <p>この度は「ネイティブの口」をご契約して頂きありがとうございます。</p>
        <p>
          ネイティブの口（{{
          plans.filter(plan => plan.id === selectedPlanId)[0].name
          }}プラン）のご契約が開始されました。
        </p>
        <p>ただいまより、3日間の無料トライアル期間が始まります。</p>
        <p>無料トライアル期間後は自動的にご指定のクレジットカードに料金が課金されます。</p>
      </div>
    </Modal>

    <div class="cc-form" style="margin-top: 40px;">
      <el-steps :active="step" align-center>
        <el-step title="ユーザー登録" icon="el-icon-user"></el-step>
        <el-step title="ご契約手続き" icon="el-icon-shopping-cart-2"></el-step>
        <el-step title="開始" icon="el-icon-check"></el-step>
      </el-steps>
    </div>

    <div class="plans">
      <div class="plan-item" v-for="(plan, index) in plans" :key="index" @click="selectPlan(plan)">
        <div class="plan-item-name">
          {{ plan.name }}
          <div class="plan-item-name-plan">プラン</div>
        </div>
        <div>
          <div class="plan-item-price">¥{{ plan.price.toLocaleString() }}</div>
          <span class="plan-item-name-tax-included">(税込み)</span>
          <span class="plan-item-name-coupon-applied" v-if="lockCoupon">(クーポン適用済み)</span>
        </div>
        <div class="plan-item-cheaper-price" v-if="plans[0].price * plan.months - plan.price">
          ¥{{
          (plans[0].price * plan.months - plan.price).toLocaleString()
          }}お得
        </div>
        <div class="plan-item-description"></div>
        <div class="plan-checkbox">
          このプランを選択
          <el-radio :label="plan.id" v-model="selectedPlanId" style="transform:scale(1.5)">{{ "" }}</el-radio>
        </div>
      </div>
    </div>
    <div class="plan-guide">
      <img :src="`guides/${selectedPlan.months}mon.png`" width="900" />
      <div class="guide-label">プラン概略図</div>
    </div>

    <div class="cc-form">
      <el-alert
        v-if="$store.state.userData.trialed && $store.state.userData.subscription.status === 'canceled'"
        type="error"
        title="注意"
        :closable="false"
        style="margin: 10px 0"
        show-icon
      >お客様は既にトライアルを完了しているので、無料期間はございません。手続き後すぐに課金が開始されますのでご注意ください。</el-alert>
      <div
        style="display:flex; width: 100%; flex-direction: column"
        :class="{ disabled: serialId }"
      >
        <div style="display: flex; flex-direction: row; width: 100%;">
          <div class="credit-field" style="flex: 1">
            <div class="label">
              有効期限
              <span class="required">必須</span>
            </div>
            <template class="field">
              <div id="card-expiry"></div>
              <span class="warning" v-if="cardExpiryError">{{ cardExpiryError }}</span>
            </template>
          </div>
          <div class="credit-field" style="flex: 3">
            <div class="label">
              クレジットカード番号
              <span class="required">必須</span>
            </div>
            <template class="field">
              <div class="card-number-container">
                <div id="card-number"></div>
                <transition name="fade">
                  <img v-if="getCardSrc(card)" :src="getCardSrc(card)" />
                </transition>
              </div>

              <span class="warning" v-if="cardNumberError">{{ cardNumberError }}</span>
            </template>
          </div>
        </div>

        <div style="display: flex; flex-direction: row; width: 100%;">
          <div class="credit-field" style="flex:2">
            <div class="label">
              名義人
              <span class="required">必須</span>
            </div>
            <template class="field">
              <input
                type="text"
                placeholder="HATSUON TARO"
                class="StripeElement"
                style="height: 38.8px; width: 100%; margin-right: 20px; box-sizing: border-box"
                :class="[
                  { complete: nameValid },
                  { error: !nameValid && cardName.length > 0 }
                ]"
                v-model="cardName"
              />
              <span class="warning">{{ nameValidationMessage }}</span>
              <!-- <span class="warning" v-if="cardNumberError">{{cardNumberError}}</span> -->
            </template>
          </div>

          <div class="credit-field" style="flex: 1">
            <div class="label">
              セキュリティコード
              <span class="required">必須</span>
            </div>
            <template class="field">
              <div id="card-cvc"></div>
              <span class="warning" v-if="cardCvcError">{{ cardCvcError }}</span>
            </template>
          </div>
        </div>
      </div>

      <div class="additional">
        <div style="display:flex; flex-direction: row">
          <div class="item" :class="{ disabled: serialId }">
            <div class="label">
              クーポンコード
              <span class="optional">（お持ちの方）</span>
            </div>
            <input
              :disabled="lockCoupon"
              :class="{ disabled: lockCoupon }"
              type="text"
              class="StripeElement"
              v-model="couponId"
            />
            <button
              class="button"
              :disabled="lockCoupon"
              :class="{ disabled: lockCoupon }"
              @click="applyCoupon()"
              style="margin-left: 10px"
            >{{ lockCoupon ? "クーポン適用済み" : "クーポンを適用" }}</button>
          </div>
          <div class="item" style="margin-left: 20px">
            <div class="label">
              シリアルコード
              <span class="optional">（お持ちの方）</span>
            </div>
            <input type="text" class="StripeElement" v-model="serialId" />
          </div>
        </div>
      </div>

      <div class="pocily-container">
        <div class="policy">
          <Policy />
        </div>

        <div class="agree">
          <el-checkbox v-model="policyAgreed" style="transform: scale(1.5)"></el-checkbox>
          <span
            style="cursor: pointer;"
            class="policy-button"
            :class="{'selected':  policyAgreed}"
            @click="policyAgreed = !policyAgreed"
          >私は未成年者でなく、又は私が未成年者の場合には、本サービスに入会し、利用契約の申込み及び締結をすること並びに利用規約の内容を利用契約の内容とすることについて、あらかじめ、私の親権者又は未成年後見人の同意を得ている旨を誓約します。</span>
        </div>
      </div>

      <div style="text-align: center; margin: 10px 0;">
        <button
          class="button"
          v-show="!serialId"
          :class="[{ disabled: !policyAgreed  || !nameValid }]"
          @click="saveToken"
        >
          <span>
            ネイティブの口（{{
            plans.filter(plan => plan.id === selectedPlanId)[0].name
            }}プラン）に入会する
          </span>
        </button>
        <button
          class="button validate"
          @click="validateSerial"
          v-show="serialId"
          :class="[{ disabled: !policyAgreed }]"
        >シリアルコードで認証</button>
      </div>
      <el-alert
        type="warning"
        title="注意"
        :closable="false"
        style="margin-top: 20px"
        show-icon
      >シリアルコードでの認証の際は、クレジットカード情報の記入は不要です。また入力した場合もクレジットカードに関する処理は行われません。</el-alert>
      <el-alert
        type="warning"
        title="注意"
        :closable="false"
        style="margin-top: 20px"
        show-icon
      >現在お申し込みのプランが終了するまでは、プランの変更はできません。</el-alert>

    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
const _ = require("lodash");
import firebase from "firebase/app";
import { db } from "@/plugins/firebase";

let style = {
  base: {
    // border: '1px solid #D8D8D8',
    // borderRadius: '4px',
    // color: "#888",
  },

  invalid: {
    // All of the error styles go inside of here.
  }
};
export default {
  components: {
    Policy: require("./Policy").default,
    Modal: require("@/components/Modal").default
  },
  watch: {
    cardName() {
      if (!this.cardName) {
        this.nameValid = false;
      }
      if (!/[a-zA-Z]{2}/.test(this.cardName) || /\d+/.test(this.cardName)) {
        this.nameValidationMessage = "2文字以上の半角英字で入力してください";
        this.nameValid = false;
      } else {
        this.nameValidationMessage = "";
        this.nameValid = true;
      }
    }
  },
  data() {
    return {
      showAllPlan: false,
      lockCoupon: false,
      nameValid: false,
      nameValidationMessage: "",
      couponId: "",
      cardName: "",
      serialId: "",
      step: 1,
      policyAgreed: false,
      selectedPlan: {
        name: "1か月",
        price: 1980,
        id: "plan_GqeeSDduPViNOO",
        // id: "plan_G5c3211Hv52d6S",
        description: "",
        months: 1
      },
      selectedPlanId: "plan_GqeeSDduPViNOO",
      // selectedPlanId: "plan_G5c3211Hv52d6S",
      plans: [
        {
          name: "1か月",
          price: 1980,
          id: "plan_GqeeSDduPViNOO",
          // id: "plan_G5c3211Hv52d6S",
          description: "",
          months: 1
        },
        {
          name: "3か月",
          price: 4980,
          id: "plan_Gqeekn43NOgBC5",
          description: "",
          months: 3
        },
        {
          name: "6か月",
          price: 7980,
          id: "plan_Gqefchk4ce9we5",
          description: "",
          months: 6
        },
        {
          name: "12か月",
          price: 12980,
          id: "plan_Gqef6RHs6dH7lQ",
          description: "¥10,780",
          months: 12
        }
      ],
      sourceAdding: false,
      Sources: {},
      expiry: null,
      cardType: "",
      stripe: new Stripe("pk_live_Ua29BMKQgKZf1HtC7EnLuocg00jmKCDQTU"),
      cardNumberError: null,
      cardExpiryError: null,
      cardCvcError: null,
      selectedSource: null,
      User: null,
      card: null,
      cardNumber: null,
      cardCvc: null,
      rules: {
        number: [
          //   { required: true, message: '入力必須です', trigger: 'blur' },
          //   { min: 3, max: 5, message: '3~5文字で入力してください', trigger: 'blur' },
          {
            required: true,
            pattern: /^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/,
            message:
              "プロダクトキーは16桁の英数字で、4桁ごとにハイフンで区切られています",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    applyCoupon() {
      let self = this;
      const checkCoupon = firebase.functions().httpsCallable("checkCoupon");
      checkCoupon({
        couponId: this.couponId
      })
        .then(result => {
          const rate = result.data;
          self.lockCoupon = true;
          self.plans = self.plans.map(plan => {
            return Object.assign(plan, { price: plan.price * (1 - rate) });
          });
          self.$notify({
            title: "成功",
            type: "success",
            duration: 0,
            message: `${rate *
              100}%OFFのクーポンが適用されました。再度上部の表からクーポン適用後の価格ご覧ください。今回と異なるクーポンを適用する際は一度ブラウザを更新してから再度入力してください。`
          });
        })
        .catch(err => {
          console.log(err);
          self.$notify({
            title: "失敗",
            type: "error",
            message: `クーポンの適用に失敗しました。正しいコードを入力しているかご確認ください。`
          });
          // self.couponId = "";
        });
    },
    validateSerial() {
      let self = this;
      const serialLoading = Loading.service({
        lock: true,
        text:
          "現在シリアルコードの認証中です、ウィンドウを閉じないようにお願い致します。",
        background: "rgba(255, 255, 255, 0.9)",
        customClass: "loading"
      });
      const validateSerial = firebase
        .functions()
        .httpsCallable("validateSerialId");
      validateSerial({ serialId: self.serialId })
        .then(() => {
          serialLoading.close();
          self.$notify({
            type: "success",
            title: "成功",
            message:
              "シリアルコードの認証に成功しました。本サービスの全機能がご利用頂けます。課金されることはございません。"
          });
          self.$router.replace("/dashboard");
        })
        .catch(err => {
          serialLoading.close();
          self.serialId = "";
          self.$notify({
            type: "error",
            title: "失敗",
            duration: 0,
            message:
              "シリアルコードの認証に失敗しました。シリアルコードを使用しない場合は、必ずシリアルコードの欄を空欄にしてください。"
          });
        });
    },
    handleLogin() {
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          // 送信処理
        }
      });
    },
    goToDashboard() {
      this.$router.replace("/dashboard");
    },
    selectPlan(plan) {
      this.selectedPlan = plan;
      this.selectedPlanId = plan.id;
    },
    getCardSrc() {
      if (this.cardType === "unknown") {
        return null;
      } else if (this.cardType) {
        return require("@/assets/cards/" + this.cardType + ".svg");
      }
    },
    saveToken(e) {
      // name validate
      let self = this;
      if (this.nameValid) {
        const cardLoading = Loading.service({
          lock: true,
          text:
            "現在クレジットカードで決済処理を行っています、ウィンドウを閉じないようにお願い致します",
          background: "rgba(255, 255, 255, 0.9)",
          customClass: "loading"
        });
        self.sourceAdding = true;
        self.stripe.createToken(this.cardNumber).then(response => {
          if (response.error) {
             self.$notify({
                type: "error",
                title: "失敗",
                message: response.error.message
              });
            cardLoading.close();
            return;
          }
          const functions = firebase.functions();
          const addPaymentSourceAndStartSubscribe = firebase
            .functions()
            .httpsCallable("addPaymentSourceAndStartSubscribe");
          return addPaymentSourceAndStartSubscribe({
            couponId: self.couponId,
            source: response,
            saveSource: true,
            selectedPlanId: self.selectedPlanId,
            name: self.cardName,
            policyAgreed: self.policyAgreed
          })
            .then(result => {
              self.$refs.modal.showModal();
            })
            .catch(err => {
              console.log(err);
              self.$notify({
                type: "error",
                title: "失敗",
                message: err
              });
            })
            .finally(() => {
              cardLoading.close();
            });
        }).catch((cardErr)=>{
           self.$notify({
                type: "error",
                title: "失敗",
                message: cardErr.message
              });
        });
      }
    }
  },
  beforeMount() {
    let self = this;
    const elements = this.stripe.elements();
    document.title = "ネイティブの口 | 課金登録";

    const status = this.$store.state.userData.subscription.status;
    console.log(status);
    if (status === "trialing" || status === "active") {
      this.$router.replace("/dashboard");
    } else if (status === "canceled") {
      // this.$norify({
      //   type: "warning",
      //   title: "トライアル期間終了",
      //   message: "トライアル期間が終了しています"
      // });
    }

    const elementStyles = {
      border: "1px"
    };
    const elementClasses = {};

    // カード番号
    this.cardNumber = elements.create("cardNumber");
    this.cardNumber.addEventListener("change", e => {
      self.cardType = e.brand;
      if (e.error) {
        this.cardNumberError = e.error.message;
      } else {
        this.cardNumberError = "";
      }
    });

    // カードの有効期限
    this.cardExpiry = elements.create("cardExpiry");

    this.cardExpiry.addEventListener("change", e => {
      if (e.error) {
        this.cardExpiryError = e.error.message;
      } else {
        this.cardExpiryError = "";
      }
    });
    // カードのCVC入力
    this.cardCvc = elements.create("cardCvc");

    this.cardCvc.addEventListener("change", e => {
      if (e.error) {
        this.cardCvcError = e.error.message;
      } else {
        this.cardCvcError = "";
      }
    });
  },
  async mounted() {
    this.cardNumber.mount("#card-number");
    this.cardExpiry.mount("#card-expiry");
    this.cardCvc.mount("#card-cvc");

    // check if already did trial

    // const trialedRef = await db.collection('trialed_user').doc(this.$store.state.auth.user.uid).get()

    // if(trialedRef.exists){
    //   this.alreadyTrialed = true;
    // }
  },
  beforeDestroy() {
    this.cardNumber.unmount("#card-number");
    this.cardExpiry.unmount("#card-expiry");
    this.cardCvc.unmount("#card-cvc");
  }
};
</script>

<style lang="scss" scoped>
.plan-guide {
  text-align: center;
  margin: 20px 0 40px 0;
  img {
    margin: 0 auto;
  }
}
.cc-form {
  margin: 0 auto;
  max-width: 700px;
}
.StripeElement {
  border: 1px solid #dcdfe6;
  background-color: #fff;
  font-size: 0.8rem;
  outline: none;
  padding: 10px 15px;
  border-radius: 5px;
  color: #606266;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  &--invalid {
    border: 1px solid #f56c6c;
  }
  &--complete {
    border: 1px solid #67c23a;
  }
  &--focus {
    border: 1px solid #b1b4bb;
  }
}

.complete {
  border: 1px solid #67c23a;
}

.error {
  border: 1px solid #f56c6c;
}
.warning {
  color: #f56c6c;
  font-size: 13px;
  margin-left: 2px;
}

table {
  width: 100%;
  margin: 20px 0;
  border-radius: 5px;
  border-spacing: 0;
  border-collapse: separate;
  text-align: center;
  box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.05);

  // box-shadow: 0 50px 100px -20px rgba(50, 50, 93, 0.25),
  // 0 30px 60px -30px rgba(0, 0, 0, 0.3),
  // 0 -18px 60px -10px rgba(0, 0, 0, 0.025);

  thead {
    background: rgba(0, 0, 0, 0.01);
    th {
      padding: 0.2rem 0;
    }
  }
  tr {
    td {
      padding: 0.4rem 0;
    }
    &:first-child {
      td {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.secure {
  text-align: center !important;
  padding: 10px 0 42px 0;
  font-size: 0.9rem;
  background: #efefef;
  border-radius: 5px;
  margin: 10px 0;
  position: relative;
  p {
    margin: 0;
  }
  img {
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    user-select: none;
    &:hover {
      opacity: 0.7;
    }
  }
}

.credit-field {
  margin: 5px;
  .label {
    margin-bottom: 5px;
  }

  .required {
    font-size: 0.75rem;
    color: #f88;
  }
}

.card-number-container {
  position: relative;
  img {
    position: absolute;
    width: 37px;
    top: 8px;
    right: 7px;
    user-select: none;
  }
}

//

.to-dashboard {
  margin-top: 10px;
}

.thankyou {
  text-align: center !important;
  font-size: 1.2rem;
  margin: 25px 0;
  font-weight: bold;
  position: relative;
  p {
    margin: 0;
  }
  img {
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    user-select: none;
    &:hover {
      opacity: 0.7;
    }
  }
}

.plans {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;

  .plan-item {
    margin: 20px 0;
    width: 200px;
    height: 270px;
    padding-top: 10px;
    border: 1px solid #eee;
    margin-left: -1px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    transition: all 0.3s ease;
    &:hover {
      z-index: 100;
      transform: scale(1.1);
      box-shadow: 0 0 25px 5px rgba(0, 0, 0, 0.15);
    }
    cursor: pointer;
    .plan-checkbox {
      justify-self: flex-end;
      width: 100%;
      padding: 10px 0;
      background-color: #f8f8f8;
      font-size: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }
    &-price {
      font-size: 2.2rem;
      text-align: center;
      margin-bottom: 5px;
    }
    &-cheaper-price {
      font-size: 1.1rem;
      color: #f88 !important;
    }
    &-name {
      font-size: 1.8rem;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #f88;
      color: white;
      border-radius: 55px;
      width: 110px;
      height: 110px;

      &-plan {
        font-size: 1rem;
      }
      &-tax-included {
        display: block;
        font-size: 0.75rem;
        margin-top: -8px;
        text-align: right;
        justify-self: flex-end;
      }
      &-coupon-applied {
        display: block;
        font-size: 0.75rem;
        /* color: #f88; */
        text-align: right;
        justify-self: flex-end;
      }
    }
  }
}

.additional {
  display: flex;
  flex-direction: row;
  margin: 5px;
  justify-content: space-between;
  align-items: center;
  .item {
    .validate {
      justify-self: flex-end;
      align-self: flex-end;
    }
    &:nth-child(2) {
      margin-left: 10px;
    }
    .optional {
      font-size: 0.8rem;
      color: #888;
      margin-left: -3px;
    }
    .label {
      margin-bottom: 5px;
    }
    input {
      padding: 8px 15px !important;
    }
  }
}

.policy {
  height: 220px;
  width: 98%;
  margin: 20px auto;
  overflow-y: scroll;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

.agree {
  text-align: left;
  display: flex;
  flex-direction: column;
  width: 650px;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  .el-checkbox {
    display: inline-block;
    margin-right: 25px;
    margin-left: 10px;
  }
}
.disabled {
  /* user-select: none;
  opacity: 0.4;
  cursor: not-allowed; */
}
.policy-button {
  &:hover {
    color: #988;
  }
}

.selected {
  color: #f88;
}
</style>
